<div class="container">
    <ul class="nav nav-tabs mt-4 mb-3" id="myTab" role="tablist">
        @for (tab of tabs; let i = $index; track i) {
        <li class="nav-item">
            <a class="nav-link nonLink" [class.active]="activeTab === i" (click)="setActiveTab(i)" id="tab{{i}}"
                role="tab" aria-controls="feed" [attr.aria-selected]="activeTab === i ? true : false">
                {{ tab }}
            </a>
        </li>
        }
    </ul>

    <div class="tab-content" id="myTabContent">
        @for (tab of tabs; let i = $index; track i) {
            @if(activeTab === i) {
                <div class="tab-pane fade" [class.show]="activeTab === i" [class.active]="activeTab === i" id="content{{i}}"
                    role="tabpanel" [attr.aria-labelledby]="'tab' + i">

                    @if (tab === 'Images') {
                    <ng-container>
                        <app-image-list></app-image-list>
                    </ng-container>
                    }

                    @if (tab === 'Icons') {
                    <ng-container>
                        Coming Soon
                    </ng-container>
                    }
                </div>
            }
        }
    </div>
</div>

